export * as giftsApi from './endpoints';
export type { TGift } from './types';
